<a href="{{apiAsset}}/{{dataDocs?.filename}}" target="_blank" class="comp-docs d-block">
    <div class="thumbnail">
        <img [src]="apiAsset + dataDocs.preview" class="w-100" alt="">
    </div>
    <h6 class="title text-center tit-f18s mt-3 mb-sm-1">{{ dataDocs?.title }}</h6>
</a>
